module.exports = __webpack_public_path__ + "img/scientist1@2x.b83f2c93.png";